export enum BuyerCustomFilter {
    All = 'all',
    Active = 'active',
    NoPaymentMethod = 'no-payment-method',
    NoBudgetRemaining = 'no-budget-remaining',
    OnHold = 'on-hold',
    TrialAccountWithCredit = 'trial-account-with-credit',
    TrialAccountWithoutCredit = 'trial-account-without-credit',
    FailingTransactions = 'failing-transactions',
    EmailDeliveryProblems = 'email-delivery-problems',
    NotInterested = 'not-interested',
}

export enum BudgetRangeEnum {
    SinceLastTransaction = 'since-last-transaction',
    AllTime = 'all-time',
}

export const NO_REP_SET = 'no-rep-set';
export type RepId = string;
// includes rep id, NO_REP_SET, and null, where null means not filtered
// eslint-disable-next-line @typescript-eslint/no-redundant-type-constituents
export type RepSelection = typeof NO_REP_SET | RepId | null;
